export default __webpack_public_path__ + "static/media/moon.73697ab9.png";